module.exports = __webpack_public_path__ + "img/liangxi.a523eb98.jpg";